import {ApiClient} from '@hconnect/apiclient'

import {BackendQuestion, RequestFunc} from '../../types'

import {loggingDecorator} from './decorators'

const getPlantQuestionsImpl: RequestFunc<string, BackendQuestion[]> = async (plantId) => {
  const {data} = await ApiClient.axiosInstance.get<BackendQuestion[]>(
    `/pom-questionnaires/${plantId}/questions`
  )
  return data
}

export const getPlantQuestions = loggingDecorator(getPlantQuestionsImpl)
